
/**
 * 该provider依赖spritejs库和next-draggable库
 */
import * as spritejs from 'spritejs';
import { install } from 'next-draggable'
install(spritejs);
const { Scene, Sprite, Polyline ,Path} = spritejs;
import { uuid } from '../utils/tools'
import generateConnectionPoints from "../utils/flow/connection-straight";
import { ResizeBlock } from './technology/resize-block';

import { EventEmitter } from '../EventEmitter.js'
import { context } from './technology/context';
import { draggable } from 'next-draggable'

// 布局配置信息
let layerConfig = []


export default class Technology extends EventEmitter {

    sprites = new Map();
    Polylines = [];

    constructor(proc) {
        super();
        this.proc = proc;
        this.data = proc.data;
        this.spritejs = spritejs;

    }


    /**
     * 创建绘制工艺的canvas舞台容器
     */
    createStage(select) {
        if (typeof select !== 'string') return;
        this.stageConatiner = document.querySelector(select);

        this.MainScene = new Scene({
            container: this.stageConatiner,
            width: this.stageConatiner.offsetWidth,
            height: this.stageConatiner.offsetHeight,
            mode: 'stickyWidth'
        })


        this.layer = this.MainScene.layer();
        let lx = 0, ly = 0
        this.layer.canvas.addEventListener('contextmenu', (event) => {
            event.preventDefault();
            if (this.pipFlag) {
                menuContent.hide()
            } else {
                menuContent.show()
            }
            lx = event.layerX;
            ly = event.layerY;
        })

        this.lineEvent()

        let menuContent = context([
            {
                label: "添加管道", val: "line", key: "line", onclick: () => {
                    this.pipFlag = true;
                    this.lineStart = [lx, ly]
                    this.createDraggablePipe({
                        id: uuid(),
                        lineWidth: 3,
                        strokeColor: "#555555",
                        lineJoin: "round"
                    })
                },
            }
        ], this.layer)
    }

    // 线条开始的坐标
    lineStart = []
    /**
     * 创建可拖拽的精灵
     * @param {object} options 
     * @returns {ResizeBlock}
     */
    createDraggableSprite(options) {
        const id = options.id || uuid();
        let spriteOptions = Object.assign({}, options, { pos: [5, 5], x: 5, y: 5, id: '' });
        const Sprite = this.createSprite(spriteOptions);

        Sprite.cname = 'sprite';

        Sprite.addEventListener('dragstart', (event) => {
            this.emit('dragstart', event);
        });

        Sprite.addEventListener('drag', (event) => {
            this.emit('drag', event);
        });

        Sprite.addEventListener('dragend', (event) => {
            this.emit('dragend', event);
        });
        const block = new ResizeBlock({
            id: id,
            pos: options.pos,
            padding: [5, 5, 5, 5],
            boxSizing: 'border-box',
            size: [options.size[0] + 10, options.size[1] + 10],
            zIndex: options.zIndex,
        });
        block.uuid = id;
        block.append(Sprite)

        block.addEventListener('contextmenu', (event) => {
            event.stopPropagation();
            this.spriteContextmenu.show()
        })

        /**
         * 创建精灵的右键菜单
         */
        this.spriteContextmenu = context([
            {
                label: "复制", val: "clone", key: "copy", onclick: (e) => {

                    const attr = Sprite.attr(),
                        blockAttr = block.attr(),
                        x = blockAttr.x,
                        y = blockAttr.y,
                        offset = 30;
                    attr.pos = [x + offset, y + offset]
                    attr.id = uuid();
                    let $options = Object.assign({}, options, attr)
                    let copySprite = this.createDraggableSprite($options)
                    this.layer.append(copySprite);

                }
            }, {
                label: "删除", val: "delete", key: "del", onclick: (e) => {
                    let delNode = this.layer.getElementById(id)
                    if (typeof delNode === 'object') {
                        delNode.remove(id);
                    }
                }
            }, {
                label: "添加管道", val: "line", key: "line", onclick: (e) => {
                    e.stopPropagation()
                    this.pipFlag = true;
                    // this.pipLine(block)
                    // this.lineStart = [block.attr().x + block.attr().size[0] / 2, block.attr().y + block.attr().size[1] / 2]
                    this.createDraggablePipe({
                        id: uuid(),
                        lineWidth: 3,
                        strokeColor: "#555555",
                        lineJoin: "round"
                    })
                },
            }, {
                label: "设置", val: "setting", key: "setting", onclick: (e) => {
                    
                    this.emit("setting", block)
                },
            }, {
                label: "上移一层", val: "up", key: "up", onclick: () => {
                    block.attr({
                        zIndex: block.attr('zIndex') + 1
                    })
                },
            }, {
                label: "下移一层", val: "down", key: "down", onclick: () => {
                    block.attr({
                        zIndex: block.attr('zIndex') - 1
                    })
                },
            }
        ], block);
        // 生成配置信息
        const attr = Sprite.attr()
        let configObj = {
            type: 'sprite',
            id: id,
            name: options.name,
            attr: { ...options, ...attr },
            children: []
        }
        layerConfig.push(configObj)
        this.layer.append(block);
        return block
    }


    /**
     * 创建管道线条
     * @param {object} config 
     */
    createPipe(config) {
        let line = new Path({
            id: config.id,
            lineWidth: config.lineWidth,
            strokeColor: config.strokeColor,
            lineJoin: config.lineJoin,
        });
        layerConfig.push({ type: 'line', id: config.id, attr: config, children: [] })
        line.type = "line";
        // this.layer.append(line);
        return line;
    }

    /**
     * 创建可拖动的管道
     * @param {object} options 
     * @returns {ResizeBlock}
     */
    createDraggablePipe(options) {
        this.spriteContextmenu.hide();
        let id = options.id || uuid();
        let line = this.pipLine(options)//this.createPipe(options);
        line.addEventListener('dragstart', (event) => {
            this.emit('dragstart', event);
        });

        line.addEventListener('drag', (event) => {
            this.emit('drag', event);
        });

        line.addEventListener('dragend', (event) => {
            this.emit('dragend', event);
        })

        line.addEventListener('mouseenter', (event) => {
            line.attr({
                strokeColor: '#cc6666'
            })
        })
        line.addEventListener('mouseleave', (event) => {
            line.attr({
                strokeColor: options.strokeColor
            })
        })
        line.uuid = id;
        draggable(line);
        this.pipeContextmenu(line);

        return line;
    }

    /**
     * 清空舞台
     */
    clearStage() {
        this.layer.removeAllChildren()
    }

    /**
     * 编辑管道
     * @param {Polyline} node 
     */
    editPipe(node) {

        this.pip = node;
        this.pos = node.attr('points');
        if (!this.lineShadow) {
            this.lineShadow = this._polyline();
            this.layer.append(this.lineShadow);
        }
        this.pipeContextmenuItem.hide();
        this.pipFlag = true;
    }

    _polyline() {
        let line = new Polyline({
            lineWidth: 3,
            strokeColor: "#555555",
            lineJoin: "round",
            className: "shadow",
        });
        return line;
    }

    /**
     * 管道的右键菜单
     * @param {Polyline} line 
     */
    pipeContextmenu(line) {
        let id = line.attr().id;
        /**
         * 管道右键菜单
         */
        this.pipeContextmenuItem = context([
            {
                label: "复制", val: "clone", key: "copy", onclick: (e) => {
                    const attr = line.attr()
                    const offset = 20;
                    attr.pos = [attr.x + offset, attr.y + offset]
                    attr.id = uuid();
                    let $options = Object.assign({}, attr)
                    let copySprite = this.createDraggablePipe($options)
                    this.layer.append(copySprite);
                }
            }, {
                label: "删除", val: "delete", key: "del", onclick: (e) => {
                    let delNode = this.layer.getElementById(id)
                    if (typeof delNode === 'object') {
                        delNode.remove(id);
                    }
                }
            }, {
                label: "编辑", val: "edit", key: "editor", onclick: (e) => {
                    e.stopPropagation();
                    this.editPipe(line)
                }
            },
            {
                label: "设置", val: "setting", key: "setting", onclick: (e) => {
                    this.emit("setting", line)
                },
            },
            {
                label: "上移一层", val: "up", key: "up", onclick: () => {
                    line.attr({
                        zIndex: line.attr('zIndex') + 1
                    })
                },
            }, {
                label: "下移一层", val: "down", key: "down", onclick: () => {
                    line.attr({
                        zIndex: line.attr('zIndex') - 1
                    })
                },
            }
        ], line)
        // 管道右键菜单
        line.addEventListener('contextmenu', (event) => {
            this.pipeContextmenuItem.show()
        })
    }

    // 已有管道
    pipes = [];
    /**
     * 管道链接
     */
    pipLine(options) {

        // pos[0] = posStart[0] = this.layer.layerX// block.attr().x + block.attr().size[0] / 2;
        // pos[1] = posStart[1] = this.layer.layerY //block.attr().y + block.attr().size[1] / 2;

        // 当前映射的线条
        this.lineShadow = this._polyline() //this._polyline();

        //总的线条
        this.pip = this.createPipe(options)// this._polyline()
        this.pip.attr({
            ...options
        })
        this.pipes.push(this.pip)
        this.layer.append(this.lineShadow, this.pip)
        return this.pip;
    }

    lineEvent() {
        this.pos = [];
        const click = (e) => {
            e.stopPropagation();
            if (this.pipFlag) {
                let x = e.layerX, y = e.layerY;
                this.pos.push(x, y);
                this.lineStart = [x, y];
                this.lineShadow.attr({
                    points: [...this.lineStart, x, y]
                })
                this.pip.attr({
                    points: this.pos
                })
            }
        }


        const mousemove = (e) => {
            e.stopPropagation();
            let x = e.layerX;
            let y = e.layerY;
            if (this.pipFlag && this.lineStart) {
                this.lineShadow.attr({
                    points: [...this.lineStart, x, y]
                })
            }
        }

        // 右键撤销
        const right = (e) => {
            e.stopPropagation()
            if (this.pos.length <= 2) return;
            this.pos.splice(this.pos.length - 2, 2)

            this.lineStart = [this.pos[this.pos.length - 2], this.pos[this.pos.length - 1]];

            this.pip.attr({
                points: this.pos
            })
        }


        const dblclick = () => {
            this.pipFlag = false;
            this.pos = []
        }

        this.layer.addEventListener('mousemove', mousemove);
        this.layer.addEventListener('click', click)
        this.layer.addEventListener('dblclick', dblclick)
        this.layer.addEventListener('contextmenu', right)
    }

    /**
     * 创建一个精灵
     * @param {object} options 
     * @returns {Sprite} 
     */
    createSprite(options = { size: [100, 100], pos: [10, 0], anchor: [0.5, 0.5] }) {
        if (!options.id) options.id = uuid();

        if (!options.name) options.name = this.sprites.size + 1;
        const box = new Sprite(options);

        box.joinId = options.joinId || null;
        // 线条的出入方向
        box.direction = options.direction || 'top';

        // 线条配置
        if (typeof options.lineStyle == 'object') {
            box.lineStyle = options.lineStyle;
        }

        this.sprites.set(options.name, box);
        // this.addLine(options)
        if (options.joinId && !Reflect.has(this.joinLine, options.id)) {
            this.joinLine[options.id] = options.joinId;
            this.joinSprite[options.id] = [];
        }
        return box;
    }

    /**
     * 添加节点到舞台
     * @param {spritejs.Node} node 
     * @returns {void}
     */
    append(node) {
        if (typeof node !== 'object') return;
        this.layer.append(node);
    }

    /**
     * 导出配置
     */
    export() {
        let $children = this.layer.children;
        const de = (children) => {
            children.forEach(child => {
                let _children = child.children;
                for (let item of layerConfig) {
                    if (child.uuid === item.id) {
                        item.attr = Object.assign({}, item.attr, child.attr())
                    }
                }
                if (_children && _children.length) {
                    de(_children)
                }
            })

        }
        de($children);
        return JSON.parse(JSON.stringify(layerConfig));
    }

    /**
     * 导入配置
     * @param {object} config 配置信息
     * @param {boolean} dev 是否是开发模式
     */
    import(config, dev) {
        if (typeof config === 'string') {
            config = JSON.parse(config)
        }
        // layerConfig = config || [];

        config.forEach(child => {
            let { attr, children } = child;
            let node = null;
            switch (child.type) {
                case 'sprite':
                    node = !dev ? this.createSprite(attr) : this.createDraggableSprite(attr);
                    break;
                case 'line':
                    !dev ? this.pipLine(attr) : this.createDraggablePipe(attr)

                    break;
            }

            if (node) this.layer.append(node);
            if (children && children.length) {
                this.import(children, dev);
            }
        })
    }

    // 所有链接点
    joinLine = {}

    // 链接的sprite
    joinSprite = {}

    /**
     * 自动添加线条
     */
    addLine() {
        // 拥有相同的jonid的sprite
        Object.keys(this.joinLine).forEach(key => {
            this.sprites.forEach(sprite => {
                if (this.joinLine[key].includes(sprite.id)) {
                    this.joinSprite[key].push(sprite)
                }
            })
        })
        Object.keys(this.joinSprite).forEach(key => {
            let sprite = Reflect.get(this.joinSprite, key);

            // 构建连接点，并链接
            let lines = this.setPos(sprite, key);
            lines.forEach(pos => {

                const line = new Path({
                    id: uuid(),
                    points: this.setDrawPos(pos),
                    lineWidth: 3,
                    strokeColor: "#555555",
                    lineDash: ['10'],
                    lineJoin: "round"
                });

                line.animate([
                    {
                        lineDashOffset: 100
                    }
                ], {
                    duration: 10000,
                    direction: 'reverse',
                    iterations: Infinity,
                })

                this.layer.append(line);
                this.Polylines.push(line);

            })
        })
    }

    //获取子元素
    /**
     * 获取子元素
     * @param {array} target 目标数组
     * @param {object} key 要获取数组对象的指定key的值的对应的子元素
     * @returns {Sprite | null}
     */
    getChildren(target, key = { key: 1, val: 1 }) {
        for (let i = 0, len = target.length; i < len; i++) {
            if (target[i][key.key] == key.val) {
                return target[i];
            }
        }
        return null;
    }

    // 设置坐标点
    setPos(sprites, key) {
        // 保存所有线条坐标的数组
        let lines = [];
        let startPos = this.getChildren(this.layer.children, { key: 'id', val: key })

        let startAttr = startPos.attr();

        let sx = (startAttr.x + startAttr.width / 2) * startAttr.scale[0];
        let sy = (startAttr.y + startAttr.height / 2) * startAttr.scale[1];
        let startObj = {
            direction: startPos.direction,
            w: startAttr.width,
            h: startAttr.height,
            x: sx,
            y: sy,
        }
        // 创建开始和结束的坐标数组
        sprites.forEach(item => {

            let line = []
            let attributes = item.attr();
            let x = (attributes.x + attributes.width / 2) * attributes.scale[0];
            let y = (attributes.y + attributes.height / 2) * attributes.scale[1];
            line[0] = startObj;
            line[1] = {
                direction: item.direction,
                w: attributes.width,
                h: attributes.height,
                x, y
            }

            lines.push(line);
        })

        return lines;
    }

    // 通过开始和结束坐标计算正交线条
    setDrawPos(lines) {
        // console.log(lines)
        if (lines.length <= 1) return;
        let start = lines[0];

        let end = lines[1];
        let { x, y } = start
        let { x: endx, y: endy } = end;

        let entryPoint = [x, y];//出
        let exitPoint = [endx, endy];//入
        switch (start.direction) {
            case 'top':
                entryPoint = [x, y + start.h]
                exitPoint = [endx, endy + end.h]
                break;
            case 'bottom':
                entryPoint = [x, y - start.h]
                exitPoint = [endx, endy - end.h]
                break;
            case 'right':
                entryPoint = [x + start.w, y]
                exitPoint = [endx + end.w, endy]
                break;
            case 'left':
                entryPoint = [x - start.w, y]
                exitPoint = [endx - end.w, endy]
                break;
        }


        let Points = generateConnectionPoints({
            entryPoint,
            exitPoint
        }, 0.8)

        let allPos = []
        Points.forEach(item => {
            allPos = [...allPos, ...item.position]
        })
        return [x, y, ...allPos, endx, endy];
    }
}